import { render, staticRenderFns } from "./PolicyEditToolbar.vue?vue&type=template&id=843d4196"
import script from "./PolicyEditToolbar.vue?vue&type=script&lang=js"
export * from "./PolicyEditToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports